import CASL from '@/utils/constants/casl'

export default [
  {
    path: 'my-profile',
    name: 'my-profile',
    meta: {
      title: 'My Profile',
      action: 'read',
      subject: CASL.ACCESS.PUBLIC
    },
    component: () => import('./detail/ProfileDetailPage.vue')
  },
  {
    path: 'my-profile/edit',
    name: 'my-profile.edit',
    meta: {
      title: 'Edit Member',
      action: 'update',
      subject: CASL.ACCESS.PUBLIC
    },
    component: () => import('./form/ProfileFormPage.vue')
  }
]
